import { render, staticRenderFns } from "./ImportSectionItems.vue?vue&type=template&id=e2e7a170&scoped=true"
import script from "./ImportSectionItems.vue?vue&type=script&lang=ts"
export * from "./ImportSectionItems.vue?vue&type=script&lang=ts"
import style0 from "./ImportSectionItems.vue?vue&type=style&index=0&id=e2e7a170&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2e7a170",
  null
  
)

export default component.exports